<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [style]="{width: '900px', height: '600px'}"
  styleClass="p-fluid p-dialog-intervento-nuovo"
  [showHeader]="true"
  header="Nuovo Intervento"
  (onHide)="hide()">

  <ng-template pTemplate="header">
    <div class="header-content">
      <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px;">construction</span>
      <span>Aggiungi intervento</span>
    </div>
  </ng-template>

  <div class="dialog-container">
    <!-- Steps -->
    <p-steps [model]="items" [activeIndex]="activeIndex" [readonly]="false" [style]="{'margin-top': '1rem'}"></p-steps>

    <!-- Contenuto principale -->
    <form [formGroup]="form" class="dialog-content" *ngIf="form">
      <!-- Step 1: Selezione Richiesta -->
      <div *ngIf="activeIndex === 0" class="step-content">
        <div class="form-group">
          <label for="richiesta">Richiesta</label>
          <p-dropdown
            id="richiesta"
            [options]="richieste"
            optionLabel="anno"
            formControlName="richiesta"
            [showClear]="true"
            placeholder="Anno della richiesta"

            [style]="{'width': '100%', 'text-align': 'left'}">
            <ng-template pTemplate="selectedItem" let-richiesta>
              <div class="selected-richiesta" style="text-align: left">
                  <span class="badge"
                    [ngStyle]="{
                      'background-color': stiliService.getColoreAnnoRichiesta(richiesta),
                      'color': '#ffffff',
                      'padding': '2px 4px',
                      'border-radius': '4px',
                      'display': 'block',
                      'width': 'fit-content',
                      'margin': '0',
                      'font-size': '14px'
                    }">
                      {{ richiesta.anno }}
                    </span>
              </div>
            </ng-template>
            <ng-template pTemplate="item" let-richiesta>
              <div class="richiesta-item" style="text-align: left">
                <span class="badge"
                  [ngStyle]="{
                    'background-color': stiliService.getColoreAnnoRichiesta(richiesta),
                    'color': '#ffffff',
                    'padding': '2px 4px',
                    'border-radius': '4px',
                    'display': 'block',
                    'width': 'fit-content',
                    'margin': '0',
                    'font-size': '14px'
                  }">
                    {{ richiesta.anno }}
                  </span>
              </div>
            </ng-template>
          </p-dropdown>

        </div>
      </div>

      <!-- Step 2: Selezione Scheda -->
      <div *ngIf="activeIndex === 1" class="step-content">
        <div class="form-group">
          <label for="scheda">Scheda</label>
          <div class="scheda-selection" style="text-align: left">
            <p-dropdown
              id="scheda"
              [options]="schede"
              optionLabel="codice"
              formControlName="scheda"
              [showClear]="true"
              placeholder="Seleziona la scheda"
              [filter]="true"
              filterBy="codice,vecchioCodiceUmvs"
              [style]="{'width': '100%'}"
              [styleClass]="'text-left'"
              [appendTo]="'body'"
              >
              <ng-template pTemplate="item" let-scheda>
                <div class="scheda-item" style="display: flex; align-items: center; gap: 0.5rem; white-space: nowrap;">
                  <div class="code-badge" style="display: inline-flex; align-items: center; background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
                    <span style="font-size: 0.8rem; color: #666; margin-right: 0.25rem;">NUOVO CODICE:</span>
                    <span class="codice-scheda-badge" style="font-weight: bold; color: #3a6e75;">{{ scheda.codice | uppercase }}</span>
                  </div>
                  <div class="code-badge" style="display: inline-flex; align-items: center; background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
                    <span style="font-size: 0.8rem; color: #666; margin-right: 0.25rem;">VECCHIO CODICE:</span>
                    <span class="vecchio-codice-umvs-badge" style="font-weight: bold; color: #666;">{{ scheda.vecchioCodiceUmvs | uppercase }}</span>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-scheda>
                <div class="scheda-item" style="display: flex; align-items: center; gap: 0.5rem; white-space: nowrap;">
                  <div class="code-badge" style="display: inline-flex; align-items: center; background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
                   <!--  <span style="font-size: 0.8rem; color: #666; margin-right: 0.25rem;">NUOVO:</span> -->
                    <span class="codice-scheda-badge" style="font-weight: bold; color: #3a6e75;">{{ scheda.codice | uppercase }}</span>
                  </div>
                  <div class="code-badge" style="display: inline-flex; align-items: center; background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
                    <!-- <span style="font-size: 0.8rem; color: #666; margin-right: 0.25rem;">VECCHIO:</span> -->
                    <span class="vecchio-codice-umvs-badge" style="font-weight: bold; color: #666;">{{ scheda.vecchioCodiceUmvs | uppercase }}</span>
                  </div>
                </div>
              </ng-template>
            </p-dropdown>
            <button
              pButton
              pRipple
              icon="pi pi-map-marker"
              class="p-button-outlined p-button-secondary"
              (click)="showMap()"
              [style]="{'margin-left': '0.5rem'}"
              pTooltip="Seleziona la scheda dalla mappa"
              pTooltipPosition="top">
            </button>
          </div>
        </div>
      </div>

      <!-- Step 3: Dettagli Intervento -->
      <div *ngIf="activeIndex === 2" class="step-content">
        <div class="form-group" style="display: flex; gap: 1rem; align-items: flex-start;">
          <div style="flex: 1;">
            <label for="tipoIntervento">Tipo Intervento</label>
            <p-dropdown
              id="tipoIntervento"
              [options]="tipiIntervento"
              optionLabel="descrizione"
              formControlName="tipoIntervento"
              [showClear]="true"
              placeholder="Seleziona il tipo di intervento"
              [style]="{'width': '100%'}"
              [styleClass]="'text-left'">
              <ng-template pTemplate="item" let-tipoIntervento>
                <div [ngStyle]="stiliService.getStileTipoInterventoDropdown(tipoIntervento.id)">
                  <i class="material-icons tipo-intervento-badge-icon">
                    {{ stiliService.getIconaTipoIntervento( tipoIntervento.id) }}
                  </i>
                  <span class="tipo-intervento-badge-value">{{ tipoIntervento.descrizione | uppercase }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-tipoIntervento>
                <div [ngStyle]="stiliService.getStileTipoInterventoDropdown(tipoIntervento.id)" pTooltip="{{ tipoIntervento.descrizione }}" tooltipPosition="top">
                  <i class="material-icons tipo-intervento-badge-icon">
                    {{ stiliService.getIconaTipoIntervento( tipoIntervento.id) }}
                  </i>
                  <span class="tipo-intervento-badge-value">{{ tipoIntervento.descrizione | uppercase }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <div style="flex: 0.6;">
            <label for="priorita">Priorità</label>
            <p-dropdown
              id="priorita"
              [options]="priorita"
              optionLabel="label"
              formControlName="priorita"
              [showClear]="true"
              placeholder="Seleziona la priorità"
              [style]="{'width': '100%', 'text-align': 'left'}"
              [styleClass]="'text-left'">
              <ng-template pTemplate="item" let-priorita>
                <div [ngStyle]="stiliService.getStilePrioritaInterventoInForm(priorita.value)" style="text-align: left">
                  <i class="material-icons" style="font-size: 18px; margin-right: 4px;">
                    {{ stiliService.getIconaPrioritaIntervento(priorita.value ) }}
                  </i>
                  <span class="ml-2">{{ priorita.label | uppercase }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="selectedItem" let-priorita>
                <div [ngStyle]="stiliService.getStilePrioritaInterventoInForm(priorita.value)" style="text-align: left">
                  <i class="material-icons" style="font-size: 18px; margin-right: 4px;">
                    {{ stiliService.getIconaPrioritaIntervento(priorita.value ) }}
                  </i>
                  <span class="ml-2">{{ priorita.label | uppercase }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <div style="flex: 1;">
            <label for="importoRichiesto">Importo Richiesto</label>
            <p-inputNumber
              id="importoRichiesto"
              formControlName="importoRichiesto"
              mode="decimal"
              [min]="0"
              [max]="1000000"
              [showButtons]="true"
              buttonLayout="horizontal"
              spinnerMode="horizontal"
              decrementButtonClass="p-button-secondary"
              incrementButtonClass="p-button-secondary"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
              placeholder="0"
              mode="currency"
              currency="EUR"
              locale="it-IT"
              [style]="{'width': '100%'}"
              [styleClass]="'text-right'">
            </p-inputNumber>
          </div>
        </div>

        <div class="form-group">
          <label for="note">Note</label>
          <textarea
            id="note"
            pInputTextarea
            formControlName="note"
            [rows]="3"
            [cols]="30"
            [style]="{'width': '100%'}"
            placeholder="Inserisci eventuali note">
          </textarea>
        </div>
      </div>
    </form>

    <!-- Separatore -->
    <div class="separator"></div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Indietro"
        icon="pi pi-arrow-left"
        class="p-button-outlined p-button-secondary"
        [disabled]="activeIndex === 0"
        (click)="goToPreviousStep()">
      </button>
      <button
        pButton
        pRipple
        [label]="activeIndex === items.length - 1 ? 'Salva' : 'Avanti'"
        [icon]="activeIndex === items.length - 1 ? 'pi pi-check' : 'pi pi-arrow-right'"
        class="p-button-primary"
        [disabled]="!isStepValid()"
        (click)="goToNextStep()">
      </button>
    </div>
  </div>
</p-dialog>
<app-mappa-scheda-nuovo-intervento></app-mappa-scheda-nuovo-intervento>
<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>
